import { ToursSearch } from 'package-types';

import { PageInfo } from '@interfaces/services/api/tours-catalog.endpoint';

export class InformationState {
  pageInfo?: PageInfo;
  departureCities: ToursSearch.DepartureCity[] = [];
}
